module.exports = __webpack_public_path__ + "static/img/shheader.94cd9f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shheader.jpg
// module id = 69wl
// module chunks = 1